import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormGroup from 'components/v2/FormGroup';
import TextAreaForm from 'components/v2/TextAreaForm';
import Helptext from 'components/v2/FormHelptext';
import CargomaticCard from 'components/v2/card';
import Alert from 'components/ui/Alert';
import PayoutResults from './PayoutResults';
export default function PayoutDocuments() {
    const { t } = useTranslation();
    const PAYOUT_NUMBER_LIMIT = {
        UPPER: 20,
    };
    const [payoutNumbersText, setPayoutNumbersText] = useState('');
    const [payoutNumbers, setPayoutNumbers] = useState([]);
    const [payoutNumberCount, setPayoutNumberCount] = useState(0);
    function onPayoutNumbersChange(value) {
        var _a;
        setPayoutNumbersText(value);
        const _payoutNumberCount = (_a = value
            .replace(/\n/g, ',')
            .split(',')
            .filter((number) => number)) === null || _a === void 0 ? void 0 : _a.length;
        setPayoutNumberCount(_payoutNumberCount);
    }
    function handleSearch() {
        const numbers = payoutNumbersText
            .replace(/\n/g, ',')
            .split(',')
            .filter((number) => number)
            .map((number) => number.trim());
        setPayoutNumbers(numbers);
    }
    function handleCancel() {
        setPayoutNumbers([]);
    }
    const isPayoutNumberLimitInRange = payoutNumberCount > 0 && payoutNumberCount <= PAYOUT_NUMBER_LIMIT.UPPER;
    return (React.createElement("div", { "data-testid": "payoutsPanel" },
        payoutNumbers.length === 0 && (React.createElement(CargomaticCard, { className: "mb-6 max-w-xl" },
            React.createElement(Helptext, { className: "mb-4" }, t('ENTER_A_LIST_OF_PAYOUT_NUMBERS_YOU_WOULD_LIKE_TO_DOWNLOAD_PAYOUTS_FOR')),
            !!payoutNumberCount && (React.createElement(Alert, { className: "flex-1 mb-2", type: payoutNumberCount > 20 ? 'error' : 'info', title: t('MAX_SEARCH_PAYOUT_NUMBER_LIMIT_EXCEEDED_ERROR', {
                    current: payoutNumberCount,
                    limit: PAYOUT_NUMBER_LIMIT.UPPER,
                }) })),
            React.createElement(FormGroup, { labelClassName: "mb-1", label: t('PAYOUT_NUMBERS') },
                React.createElement(TextAreaForm, { placeholder: t('COMMA_SEPARATED_VALUES'), className: "w-full", value: payoutNumbersText, onChange: onPayoutNumbersChange, actionName: t('SEARCH'), showAction: true, rows: 4, onActionClick: handleSearch, disabledBtn: !isPayoutNumberLimitInRange, name: "commaSeparatedValues" })))),
        payoutNumbers.length > 0 && (React.createElement(PayoutResults, { payoutNumbers: payoutNumbers, handleCancel: handleCancel }))));
}
